/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{ useEffect } from "react"; 
import { Outlet } from "react-router-dom";
import TitleBar from "./TitleBar";
import TabBar from "./TabBar";
import Menus from "./Menus";

/* css */
import "../../../css/admin_layout.css";

const AdminFlatForm = () => {
  
  useEffect(() => {
    //페이지 크기 재설정
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="admin_baseform">
      <TitleBar/>
      <TabBar/>
      <Menus/>
      <div className="layer-bg"></div>
      <Outlet/>
    </div>
  );
}
export default AdminFlatForm;